import { connect } from 'react-redux';
import { Link } from "react-router-dom";

var AccountPlans = require("lib/account/AccountPlans");
var LoadingButton = require("components/utility/LoadingButton");
var CreditCardInput = require("components/payments/CreditCardInput");
var PurchaseOrderInput = require("components/payments/PurchaseOrderInput");
var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require("lib/web/WhooosReadingServices")
var ButtonDropdown = require("components/utility/ButtonDropdown");
var DropDownOptions = require("components/utility/DropDownOptions");
var ButtonDropdownOption = require("components/utility/ButtonDropdownOption");
var Glyphicon = require("components/utility/icons/Glyphicon");
var ErrorDisplay = require("components/utility/ErrorDisplay");
var Cookies = require("js-cookie");

var Spinner = require("components/utility/Spinner");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var UpgradeTokenForm = require("components/users/teachers/upgrade/UpgradeTokenForm");
var FacebookPixelClient = require("lib/integrations/FacebookPixelClient");

const DISCOUNT_CODE_KEY = "DISCOUNT_CODE_KEY";

require("users/teachers/upgrade/upgrade_form.scss");

function getDiscountCode() {
	let discountCode = $wr.getURLParameterByName("discount_code")

	if (discountCode) {
		Cookies.set(DISCOUNT_CODE_KEY, discountCode, { expires: 10 });		
		return discountCode;
	}


	discountCode = Cookies.get(DISCOUNT_CODE_KEY);
	if (discountCode) {
		return discountCode;
	}
}

function clearDiscountCodeCookie() {
	Cookies.remove(DISCOUNT_CODE_KEY);
}

@connect(
	(state, props) => ({
		studentLists: RosterSelectors.nonEmptyStudentLists({ state }),
		loadingStudentLists: RosterSelectors.isLoadingStudentLists({ state }),
		existingPlanStudentListCount: CurrentUser.get().account.plan_student_list_count || 1,
		possibleDiscountToken: RosterSelectors.discountToken({ state, code: getDiscountCode() })
	}),

	(dispatch, props) => ({
		populateData: () => {
			var discountCode = getDiscountCode();
			if (discountCode) {
				return dispatch(RosterActions.fetchDiscountToken({ code: discountCode }));
			} else {
				return Promise.resolve();
			}
		},

		upgradeAccount: ({ discountCode, planType, studentListCount, cardTokenData }) => {
			var account = {
				plan_type: planType,
				student_list_count: studentListCount
			}

			return dispatch(RosterActions.updateAdmin({
				id: CurrentUser.get().id,
				update: { account },
				query: {
					discount_code: discountCode,
					card_token_data: cardTokenData
				}
			}))

		}
	})
)
class UpgradeForm extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			selectedPaymentText: "Credit Card",
			selectedClassCount: null, loading: false,
			showCardFields: false, purchaseOrderValues: {}
		};
	}

	////// URL Helper Functions //////
	currentURL() {
		return new URL(window.location.href);
	}

	changeTimeURL() {
		var currentURL = this.currentURL()

		if (this.props.possibleDiscountToken) {
			currentURL.searchParams.set('discount_code', this.props.possibleDiscountToken.code)
		}

		if (this.isSemester()) {
			currentURL.searchParams.set('period', 'year')
			return `/upgrade${currentURL.search}`
		} else {
			currentURL.searchParams.set('period', 'semester')
			return `/upgrade${currentURL.search}`
		}
	}

	changeProductURL() {
		var currentURL = this.currentURL()
		if (this.props.product == 'silver') {
			currentURL.searchParams.set('plan', 'gold')
			return `/upgrade${currentURL.search}`
		} else {
			currentURL.searchParams.set('plan', 'silver')
			return `/upgrade${currentURL.search}`
		}
	}
	/////////////////////////////////

	isSemester() {
		return this.props.period == "semester";
	}

	planType() {
		if (this.props.product == "silver") {
			if (this.isSemester()) {
				return AccountPlans.SILVER_SEMESTER_PLAN_2019;
			} else {
				return AccountPlans.SILVER_PLAN_2019;
			}
		} else if (this.props.product == "gold") {
			if (this.isSemester()) {
				return AccountPlans.GOLD_SEMESTER_PLAN;
			} else {
				return AccountPlans.GOLD_PLAN;
			}
		}
	}

	appliedDiscountToken() {
		var token = this.props.possibleDiscountToken
		if (token && (token.plan_type == this.planType())) {
			return token;
		}
	}

	timeDisplay() {
		if (this.isSemester()) {
			return "6 months";
		} else {
			return "1 year";
		}
	}

	subTotalPrice() {
		if (this.props.product == 'silver') { 
			return AccountPlans.price(this.planType(), this.numClassesSelected())
		} else {
			return AccountPlans.tieredPrice({ plan: this.planType(), studentListCount: this.numClassesSelected() })
		}
	}
	existingPlanValue() {
		return CurrentUser.get().account.existing_plan_value;
	}
	togglePaymentType(e) {
		$wr.nope(e)
		this.setState({ showCardFields: !this.state.showCardFields });
	}
	creditCardFieldsVisible() {
		return this.state.showCardFields || !CurrentUser.get().account.has_credit_card;
	}

	// selectClasses(event) {
	// 	this.setState({ selectedClassCount: parseInt(event.target.value) });
	// }

	selectClasses(count) {
		this.setState({ selectedClassCount: count });
	}

	numClassesSelected() {
		var defaultAmount = this.props.classCount || Math.max(this.props.studentLists.length, 
			this.props.existingPlanStudentListCount)
		return this.state.selectedClassCount || defaultAmount;
	}

	selectPaymentType(paymentText) {
		this.setState({ selectedPaymentText: paymentText, showCardFields: false });
	}
	onPurchaseOrderChange(purchaseOrderValues) {
		this.setState({ purchaseOrderValues });
	}
	selectedCreditCard() {
		return this.state.selectedPaymentText == "Credit Card";
	}

	upgradeAdmin(cardTokenData) {
		var upgradeArgs = {
			planType: this.planType(),
			studentListCount: this.numClassesSelected()
		}

		if (cardTokenData) {
			upgradeArgs.cardTokenData = cardTokenData;
		}

		if (this.appliedDiscountToken()) {
			upgradeArgs.discountCode = this.appliedDiscountToken().code;
		}

		this.props.upgradeAccount(upgradeArgs).then(() => {
			Mycroft.newEvent({ category: "Upgrade", action: "pay-by-cc", label: this.props.product });

			window.wrNotifications.triggerDropDownNotification({
				title: "Thank You!",
				text: "You have upgraded your account to " + $wr.capitalize(this.props.product) + "!",
				icon: "star"
			}, 5000);

			FacebookPixelClient.upgrade(this.subTotalPrice() / 100);

			if (this.props.afterUpgrade) {
				this.props.afterUpgrade();
			} else {
				CurrentUser.fetchCurrentUserData(() => {
					this.setState({ loading: false });
					$wr.redirect("/");
				});
			}
		})
	}

	sendPOInfo(poFields) {
		var user = CurrentUser.get();
		poFields = _.extend({}, poFields, {
			plan_type: this.planType(),
			student_list_count: this.numClassesSelected(),
			existing_plan_value: $wr.centsToDollars(this.existingPlanValue())
		});

		var purchaseInfoText = _.map(_.pairs(poFields), (pair) => {
			return pair.join(": ");
		}).join("\n\n");

		var message = "Purchase Order Request\n\n" + purchaseInfoText;

		var params = {
			contact_message: {
				message: message
			},
			purchase_order: true
		}

		this.setState({ loading: true });
		CurrentUser.api().postContactMessages(params, () => {
			Mycroft.newEvent({ category: "Upgrade", action: "pay-by-po", label: this.props.product });

			window.wrNotifications.triggerDropDownNotification({
				title: "PO Request Received!",
				text: "We'll send a quote to your accounts payable contact.",
				icon: "star"
			}, 5000);
			$wr.redirect("/");
		});
	}

	onSubmit(e) {
		$wr.nope(e)

		if (this.selectedCreditCard()) {
			this.setState({ loading: true });

			var currentUser = CurrentUser.get()
			var userData = { name: (currentUser.first_name + " " + currentUser.last_name),
				email: currentUser.email };

			if (this.creditCardFieldsVisible()) {
				this.refs.creditCard.tokenize(userData, (success, tokenData) => {
					if (success) {
						this.upgradeAdmin(tokenData)
					} else {
						this.setState({ loading: false });
					}
				});

			} else {
				this.upgradeAdmin();
			}
		} else {
			this.refs.poErrors.reset();

			var poFields = _.clone(this.state.purchaseOrderValues);
			var requiredFields = _.reject(poFields, (val, key) => { return key == "comments" });
			var nonBlankCount = _.select(_.values(requiredFields), (t) => t.trim().length > 0).length;
			if (nonBlankCount < 3) {
				this.refs.poErrors.setError(
					"Please provide a name, email, and phone number for your school's purchasing contact."
				);
				return;
			}

			this.sendPOInfo(poFields);
		}
	}

	calculateDiscount(classCount) {
		var token = this.appliedDiscountToken();
		var plan = this.planType();

		var discount = 0;
		if (token) {
			if (token.fixed_discount) {
				discount += token.fixed_discount;
			}
			if (token.fixed_price) {
				discount += AccountPlans.fixedPrice(plan) - token.fixed_price;
			}
			if (token.per_class_price) {
				discount += (AccountPlans.perClassPrice(plan) - token.per_class_price) * classCount;
			}
		}

		return discount;
	}

	removeDiscount(e) {
		$wr.nope(e);

		var switchURL = "/upgrade?plan=" + this.props.product;
		switchURL += "&period=" + (this.isSemester() ? "semester" : "year");

		clearDiscountCodeCookie()

		$wr.redirect(switchURL);
		this.props.populateData()
	}

	renderDiscountInfo() {
		var token = this.appliedDiscountToken();

		if (token) {
			if (token.end_date) {
				var expiration = "Discount expires: " + $wr.formatDate(token.end_date);
			}
			return (
				<div className="discountInfo clearfix">
					{ expiration }

					<a className="removeLink" href="#" onClick={ this.removeDiscount }>
						<Glyphicon icon="remove" /> Remove discount
					</a>
				</div>
			)
		}
	}

	renderPlanContent() {
		var selectedContent = null;
		var numSelected = this.numClassesSelected();

		var numClassesOptions = _.map(Array(MAX_CLASSES - 1).fill(), (_, index) => {
			var classCount = index + 1;
			var classesText = $wr.pluralizeWithNumber("class", classCount, "classes");

			if (this.props.product == 'silver') {
				var basePrice = AccountPlans.price(this.planType(), classCount);
			} else {
				var basePrice = AccountPlans.tieredPrice({ plan: this.planType(), studentListCount: classCount })
			}

			var basePriceText = $wr.centsToDollars(basePrice, true);

			var discount = this.calculateDiscount(classCount);

			if (discount == 0) {
				var periodText = this.isSemester() ? "/semester" : "/year";

				var optionDisplay = (
					<span>
						{ classesText } - { basePriceText }{ periodText }
					</span>
				)
			} else {
				var discountedPriceText = $wr.centsToDollars(basePrice - discount, true);
				var optionDisplay = (
					<span>
						{ classesText } - <span className="originalPrice">
							{ basePriceText }
						</span> { discountedPriceText }{ periodText }
					</span>
				)
			}


			if (classCount == numSelected) {
				selectedContent = optionDisplay;
			}

			return (
				<ButtonDropdownOption onClick={ this.selectClasses.bind(this, classCount) }
					text={ optionDisplay } key={ classCount } />
			)
		});

		if (this.props.loadingStudentLists) {
			var planPriceContent =  (
				<div><Spinner placeholder={ true } scale={ 1.7 } /></div>
			);
		} else {
			var numClassesDropdown = (
				<ButtonDropdown text={ selectedContent } dropdownDisplay="button">
					{ numClassesOptions }
				</ButtonDropdown>
			)

			if (this.numClassesSelected() >= MAX_CLASSES) {
				var planPriceContent = (
					<div className="contactUsLink">
						<a href={ WhooosReadingServices.OuterPages.url("/schools#contactForm") }>
							Contact us
						</a>
					</div>
				);
			}
		}

		var changeTimeText = this.isSemester() ? 'Switch to Annual' : 'Switch to Semester'
		var changePricingLink = <Link to={this.changeTimeURL()}>{changeTimeText}</Link>
		
		var changeProductURL = this.changeProductURL()

		return (
			<div className="planContent">
				<div className="planBoxHeader">
					Your plan
					<a href={ changeProductURL } 
						className="changePlanLink">Change plan</a>
				</div>
				<div className="planDetailsBox">
					<div className="planDetails">
						{ this.timeDisplay() } of WR { $wr.capitalize(this.props.product) }
						<span className="verticalDivider"></span>
						{ changePricingLink }
					</div>
					<div className="classesPricing">
						{ numClassesDropdown }
						{ planPriceContent }
					</div>

					{ this.renderDiscountInfo() }
				</div>
			</div>
		);
	}

	renderPaymentContent() {
		var paymentOptions = DropDownOptions.Button.simpleText({
			options: ["Credit Card", "Purchase Order", "Upgrade Code"],
			onClick: this.selectPaymentType
		});
		var paymentTypeDropdown = (
			<ButtonDropdown text={ this.state.selectedPaymentText } dropdownDisplay="button"
				className="paymentTypeDropdown">
				{ paymentOptions }
			</ButtonDropdown>
		);

		var existingValue = this.existingPlanValue();
		var oneTimeDiscount = this.calculateDiscount(this.numClassesSelected());
		var subTotalPrice = this.subTotalPrice();

		if (this.selectedCreditCard()) {
			if (this.creditCardFieldsVisible()) {
				var paymentInfo = { stripe_public_key: CreditCardInput.STRIPE_PUBLIC_KEY };
				var paymentForm = (
					<CreditCardInput ref="creditCard" paymentInfo={ paymentInfo } />
				);

			} else {
				var paymentForm = (
					<div className="existingPaymentMethod">
						Payment Method: { CurrentUser.paymentMethodSummary() }<br />
						<a href="#" onClick={ this.togglePaymentType } className="changeLink">
							Change payment method
						</a>
					</div>
				)
			}

			if (this.isSemester()) {
				var chargeText = "charge you every 6 months"
			} else {
				var chargeText = "charge you every year"
			}

			if ((oneTimeDiscount + existingValue) > 0) {
				var higherRenewalMessage = (
					<span>
						This plan will renew at the regular price of { $wr.centsToDollars(subTotalPrice, false) }.
					</span>
				)
			}

			var purchaseDisclaimer = (
				<div className="purchaseDisclaimer">
					By completing this purchase, you authorize Whooo's Reading
					to { chargeText } until you cancel your subscription.
					{" "}{ higherRenewalMessage } 
				</div>
			);
			var submitText = "Complete Purchase";
		} else {
			if (this.state.selectedPaymentText == UPGRADE_CODE) {
				var upgradeForm = (<UpgradeTokenForm showCompleteButton={ true } loadingStudentLists={ this.props.loadingStudentLists} />)
			} else {
				var paymentForm = (
					<div>
						<ErrorDisplay ref="poErrors" />
						<PurchaseOrderInput values={ this.state.purchaseOrderValues }
							onChange={ this.onPurchaseOrderChange } />
					</div>
				);
				var purchaseDisclaimer = (
					<div className="purchaseDisclaimer">
						We will provide a formal quote to the contact above and turn on your
						paid features once we receive a purchase order.
					</div>
				);

				var submitText = "Submit PO Request";
			}
		}

		if (this.state.selectedPaymentText != UPGRADE_CODE) {
			var submitButton = (
				<div className="submitButton">
					<LoadingButton className="btn buttonSuccess"
						onClick={ this.onSubmit } text={ submitText }
						loading={ !!(this.state.loading || this.props.loadingStudentLists) } />
				</div>
			)

			var amountClass = "totalDollars";

			var totalPrice = subTotalPrice;

			var discountMessage = "";

			if (existingValue && existingValue > 0) {
				totalPrice = totalPrice - existingValue;

				discountMessage = "You are getting a " +
					$wr.centsToDollars(existingValue, false) + 
					" discount based on value remaining on your current plan."

				var existingValueDiscountSection = (
					<span className="subtotalLine">
						<br /><span className="totalLabel">Discount:</span>
						-{ $wr.centsToDollars(existingValue, false) }
					</span>
				)

			}

			if (oneTimeDiscount && oneTimeDiscount > 0) {
				totalPrice = totalPrice - oneTimeDiscount;

				if (discountMessage.length > 0) {
					discountMessage += " You are also ";
				} else {
					discountMessage += "You are ";
				}

				discountMessage += "getting a one-time ";

				discountMessage += $wr.centsToDollars(oneTimeDiscount, false) + " discount.";

				var oneTimeDiscountSection = (
					<span className="subtotalLine">
						<br /><span className="totalLabel">Discount:</span>
						-{ $wr.centsToDollars(oneTimeDiscount, false) }
					</span>
				)
			}

			if (totalPrice < 0) {
				totalPrice = 0;
			}

			if (existingValueDiscountSection || oneTimeDiscountSection) {
				var subTotalSection = (
					<div className="subTotalSection">
						<span className="totalLabel">Subtotal:</span>
						{ $wr.centsToDollars(subTotalPrice, false) }
						{ existingValueDiscountSection }
						{ oneTimeDiscountSection }
					</div>
				);				
			}

			var totalPriceDisplay = $wr.centsToDollars(totalPrice, false);

			if (totalPrice == subTotalPrice) {
				amountClass += " noSubtotal";
			}

			if (discountMessage.length) {
				var discountMessageDisplay = (
					<div className="discountMessage">{ discountMessage }</div>
				)
			}

			var submitSection = (
				<div className="submitPayment">
					{ discountMessageDisplay }
					<div className="totalAmount">
						{ subTotalSection }
						<span className="totalLine">
							<span className="totalLabel">Total:</span>
							<span className={ amountClass }>
								{ totalPriceDisplay }
							</span>
						</span>
					</div>
					{ submitButton }
				</div>
			);
			var term = "purchase";
		} else {
			var term = "upgrade";
		}

		var termsLink = (
			<a href={ WhooosReadingServices.OuterPages.url("/terms") }>
				Terms of Service
			</a>
		);
		var privacyLink = (
			<a href={ WhooosReadingServices.OuterPages.url("/privacy") }>
				Privacy Policy
			</a>
		);

		var termsDisclaimer = (
			<div className="termsDisclaimer">
				By completing this { term }, you agree to our { termsLink } and { privacyLink }.
			</div>
		);

		return (
			<div className="paymentContentContainer">
				<div className="paymentChoiceLabel">
					Choose your payment method
				</div>
				{ paymentTypeDropdown }
				{ paymentForm }
				{ upgradeForm }
				{ purchaseDisclaimer }
				{ submitSection }
				{ termsDisclaimer }
			</div>
		);
	}

	render() {
		// only display payment content if less than MAX_CLASSES classes selected
		if (this.numClassesSelected() < MAX_CLASSES) {
			var paymentContent = this.renderPaymentContent();
		}

		return (
			<div className="upgradeForm">
				<div className="container upgradeContainer">
					{ this.renderPlanContent() }
					{ paymentContent }
				</div>
			</div>
		);
	}

	componentDidMount() {
		this.props.populateData();
		FacebookPixelClient.init();
	}

};

var MAX_CLASSES = 7;

var UPGRADE_CODE = "Upgrade Code";

UpgradeForm.WrappedComponent.propTypes = StrictPropTypes({
	// From @connect
	studentLists: PropTypes.array.isRequired,
	existingPlanStudentListCount: PropTypes.number.isRequired,
	loadingStudentLists: PropTypes.bool,
	populateData: PropTypes.func.isRequired,
	upgradeAccount: PropTypes.func.isRequired,
	possibleDiscountToken: PropTypes.object,
	classCount: PropTypes.number,

	product: PropTypes.string.isRequired,
	period: PropTypes.string.isRequired,
	afterUpgrade: PropTypes.func

});

module.exports = UpgradeForm;



// WEBPACK FOOTER //
// ./modules/components/users/teachers/upgrade/UpgradeForm.js